import { createFileRoute, redirect } from "@tanstack/react-router";

// The old page lives on as a permanent redirect so existing links and search results keep working.
export const Route = createFileRoute("/solutions")({
  beforeLoad: () => {
    throw redirect({ to: "/platform", statusCode: 301 });
  },
});
